import { createFileRoute } from '@tanstack/react-router';
import AdminAccount from '../../pages/admin/Account';

export const Route = createFileRoute('/admin/account')({
  component: AdminAccount,
});
